function ocultarElementosFueraDeItalia() {
  var urlActual = window.location.href;

  // Verifica si la URL NO contiene '.it'
  if (!urlActual.includes('.it')) {
    var formulario = document.querySelector('[id*="app-embed-container-166404"]');
    var divAppRouter = document.querySelector('div[data-testid="app-router"]');
    var botonTeaser = document.querySelector('button[data-testid="teaser-container"]');

    if (formulario) {
      formulario.style.display = 'none';
    }

    if (divAppRouter) {
      divAppRouter.style.display = 'none';
    }

    if (botonTeaser) {
      botonTeaser.style.display = 'none';
    }
  }
}

function observarCambiosFueraDeItalia() {
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0 || mutation.type === 'attributes') {
        ocultarElementosFueraDeItalia();
      }
    });
  });

  // Observa los cambios en todo el documento, no solo en el body
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true });

  // Añadir un pequeño retraso para asegurar que los elementos están presentes
  setTimeout(ocultarElementosFueraDeItalia, 1000); // Ajusta el retraso si es necesario
}

document.addEventListener('DOMContentLoaded', observarCambiosFueraDeItalia);
